import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";

import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddItems extends Component {
  handleEditData = () => {
    this.props.handleEditStatus(false);
    this.props.handleEditItem(this.props.index, this.props.itemData);
  };

  render() {
    const { classes, itemData, handleChange, handleSubmit } = this.props;
    return (
      <TableRow>
        <TableCell align="center" />
        <TableCell align="center">
          <TextField
            name="itemName"
            type="text"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={itemData.itemName}
            onChange={handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="quantity"
            type="number"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={itemData.quantity}
            onChange={handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="rate"
            type="number"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={itemData.rate}
            onChange={handleChange}
          />
        </TableCell>
        <TableCell align="center">
          Rs. {parseFloat(itemData.quantity * itemData.rate)}
        </TableCell>
        <TableCell align="center">
          <TextField
            name="purchasedFrom"
            type="text"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={itemData.purchasedFrom}
            onChange={handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="purchasedDate"
            type="date"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={itemData.purchasedDate}
            onChange={handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                title="Update"
                arrow
                onClick={this.props.handleEdit}
                className={classes.tooltip}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                title="Cancel"
                arrow
                onClick={() => this.props.handleEditStatus(false)}
                className={classes.tooltip}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              title="Add"
              arrow
              onClick={handleSubmit}
              className={classes.tooltip}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
          <br />
          {this.props.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(AddItems);
